export default "__VITE_ASSET__FMwrGaX$__"